import React, { Component } from 'react';
import { connect } from 'react-redux';
import MessageBanner from './MessageBanner';

class BannerContainer extends Component {
    render() {
        return (
           <MessageBanner banners={this.props.banners}/>
        );
    }
}

const mapStateToProps = state => ({
    banners: state.messageBanner,
});


const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BannerContainer);
